import { get, post, del, put as update } from "helpers/api_helper";

const createRequest = async data => {
  return await post("/api/CodeColor", data);
};
const getRequest = async () => {
  return await get("/api/CodeColor");
};
const getByIdRequest = async id => {
  return await get(`/api/CodeColor/${id}`);
};

export const codeColorService = {
  createRequest,
  getRequest,
  getByIdRequest,
};
